export const buildingDetailSections = [
  { value: 'overview', label: 'Přehled' },
  { value: 'energy', label: 'Spotřeba a výroba' },
  { value: 'card', label: 'Karta budovy' },
  { value: 'documents', label: 'Dokumenty' },
  { value: 'inspections', label: 'Revize' },
] as const;

export type BuildingDetailSection = typeof buildingDetailSections[number]['value'];
export type CollectionPointDataSource = 'readings' | 'invoices' | 'solar' | 'interval';

export const collectionPointDataSources: Array<{ value: CollectionPointDataSource; label: string }> = [
  { value: 'readings', label: 'Stavy z odečtů' },
  { value: 'invoices', label: 'Vyúčtování z faktur' },
  { value: 'solar', label: 'FVE' },
  { value: 'interval', label: 'Průběhové měření' },
];

export function getBuildingDetailEnergySearch(source: CollectionPointDataSource, collectionPointId?: string | null, range?: { from: string; to: string } | null): string {
  const search = new URLSearchParams({ section: 'energy', source });
  if (collectionPointId) search.set('collectionPointId', collectionPointId);
  if (range) {
    search.set('from', range.from);
    search.set('to', range.to);
  }
  return `?${search.toString()}`;
}

export function getBuildingDetailNavigation(search: URLSearchParams, hash = '') {
  const requestedSection = search.get('section');
  const section: BuildingDetailSection = hash === '#revisions'
    ? 'inspections'
    : search.has('collectionPointId') || ['billing', 'egd', 'fve'].includes(requestedSection ?? '')
      ? 'energy'
      : buildingDetailSections.find(item => item.value === requestedSection)?.value ?? 'overview';
  const source = search.get('source');
  const dataSource: CollectionPointDataSource = collectionPointDataSources.find(item => item.value === source)?.value
    ?? (requestedSection === 'egd' ? 'interval' : requestedSection === 'fve' ? 'solar' : requestedSection === 'billing' ? 'invoices' : 'readings');
  return { section, dataSource };
}
